import { createAPI } from '../../common'

export default {
    // 获取根节点
    getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gpmefst0sppu', 'get', config),
    // 获取子节点
    getSubs: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'get', config),
    // 获取根文件夹
    // getCatRoot: (config) =>
    //     createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0spput', 'get', config, {
    //         neverLoading: true
    //     }),
    // getCatSub: (config, vconfig) =>
    //     createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbut', 'get', config, vconfig),
    //创建分组
    postFolderCat: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs', 'post', config),
    putFolderCat: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs', 'put', config),
    // 删除分组
    deleteFolderCat: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs', 'Delete', config),
    // 获取字段设置
    getFields: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0gjfmet', 'get', config),
    // 获取详情
    getDetailFun: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0efubjm', 'get', config),
    // 获取审核作者的详情
    getReviewDetailFun: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0sfwjfx0efubjm', 'get', config),
    //保存字段设置
    postFieIds: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0gjfmet', 'post', config),
    //专家删除
    deleteExpert: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0efmfuf', 'Delete', config),
    //专家解聘
    postDismiss: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0ejtnjtt', 'post', config),
    //专家审核
    postReview: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0sfwjfx', 'post', config),
    // 模版下载
    getTemplate: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0fyqfsuJogpJnqpsu0ufnqmbuf', 'get', config),
    // 模版导入
    postInfoTemplate: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0fyqfsuJogpJnqpsu', 'post', config),
    //新建专家
    postExpert: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0tbwf', 'post', config),
    //同步修改专家分组
    postUpdateCat: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0vqebufDbu', 'post', config),
    // 同步删除专家分组
    postDeleteCat: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0efmfufDbu', 'post', config),
    // 专家聘任
    postAppoint: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0bqqpjou', 'post', config),
    // 专家下载
    getExpertDownload: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0fyqfsu0epxompbe', 'get', config),
    //获取专家分类
    getExpertCatType: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0spput', 'get', config),


}
